/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   German counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-de.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.de = window.TD_I18N.de || {};
  Object.assign(window.TD_I18N.de, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr. K. Alvin Ronlán · Forschung und Werdegang — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Forschung und Werdegang',
    'ronlan.headTitle': 'Dr. K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Gründer, Director of R&amp;D. Drei Jahrzehnte Phenolchemie, jetzt angewandt auf die Haut.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'Im Überblick',
    'ronlan.facts.bornK': 'Geburt',
    'ronlan.facts.bornV': '15. August 1942, Kopenhagen, Dänemark',
    'ronlan.facts.domK': 'Wohnsitz',
    'ronlan.facts.domV': 'Florida, USA',
    'ronlan.facts.langK': 'Sprachen',
    'ronlan.facts.langV': 'Dänisch, Schwedisch, Englisch, Deutsch',
    'ronlan.facts.roleK': 'Aktuelle Position',
    'ronlan.facts.roleV': 'R&amp;D Director, Alron Chemical Co AB · Mitgründer, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Ausbildung',
    'ronlan.eduTitle': 'Vier Abschlüsse,<br><em>drei Länder.</em>',
    'ronlan.edu1h': 'B.Sc. · Mathematik, Physik, Chemie',
    'ronlan.edu1p': 'Universität Kopenhagen und Technisches Institut Dänemark.',
    'ronlan.edu2h': 'M.Sc. · Physik und Chemie',
    'ronlan.edu2p': 'Universität Uppsala, Schweden.',
    'ronlan.edu3h': 'Ph.D.',
    'ronlan.edu3p': 'Royal Institute of Technology, Stockholm, Schweden.',
    'ronlan.edu4h': 'Doctor of Science',
    'ronlan.edu4p': 'Universität Lund, Schweden.',

    /* ── Career ── */
    'ronlan.carLabel': 'Karriere',
    'ronlan.carTitle': 'Von der Akademie<br><em>ins Labor.</em>',
    'ronlan.carIntro': 'Sechs Jahrzehnte Lehre, Forschung und angewandte Chemie. Die wichtigsten Stationen unten.',
    'ronlan.car1h': 'Assistent, Universität Uppsala',
    'ronlan.car1p': 'Erste Lehrposition während des Masterstudiums.',
    'ronlan.car2h': 'Forschungsassistent, Royal Institute of Technology, Stockholm',
    'ronlan.car2p': 'Seine Promotionsjahre in Stockholm.',
    'ronlan.car3h': 'Docent, Universität Lund',
    'ronlan.car3p': 'Beginnt die Arbeit an Phenolchemie und anodischer Oxidation, die später die Transderma-Formulierung tragen wird.',
    'ronlan.car4h': 'Dozent, Universität Lund',
    'ronlan.car5h': 'Professor, Universität Lund',
    'ronlan.car5p': 'Befördert zum Professor für bioorganische Chemie, leitet die Forschungsgruppe zu phenolischen Antioxidantien und Kationenradikalen.',
    'ronlan.car6h': 'Leiter des Chemiedepartments, Universität Lund',
    'ronlan.car6p': 'Leitet das Chemiedepartment der Universität Lund.',
    'ronlan.car7h': 'Director of R&amp;D, Alron Chemical Co AB',
    'ronlan.car7p': 'Laufend · gründet das Labor 1977 für Oberflächenchemie und -physik sowie Verbrennungskatalyse. Im selben Jahr wird auch Alron Japan, Inc. in Tokio gegründet.',
    'ronlan.car8h': 'Gastprofessor, University of California, Santa Cruz',
    'ronlan.car8p': 'Wendet die aufkommende künstliche Intelligenz auf chemische und biochemische Probleme an.',
    'ronlan.car9h': 'Mitgründer und R&amp;D Director, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Mit Graziella Gallelli Ronlan. Forschung und Entwicklung mit Sitz in Florida.',
    'ronlan.car10h': 'Berater, Erco Pharmaceuticals',
    'ronlan.car10p': 'Mitautor von Patenten zu Kontrastmitteln und Antihypertensiva.',
    'ronlan.car11h': 'Ostafrika-Expedition',
    'ronlan.car11p': 'Organisierte und leitete eine viermonatige Expedition durch Kenia, Tansania und Uganda zur Sammlung von Heilpflanzen.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Ausgewählte Publikationen',
    'ronlan.pubTitle': 'Phenole, Antioxidantien,<br><em>Kationenradikale.</em>',
    'ronlan.pubIntro': 'Zehn peer-reviewte Artikel, die die Chemie hinter den Transderma-Formulierungen zeigen. Die vollständige Bibliographie mit 31 Artikeln ist im Lebenslauf-Download verfügbar.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Mit Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Mit Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Mit V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Mit V.D. Parker und U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'Die vollständige Bibliographie mit 31 peer-reviewten Artikeln ist im Lebenslauf-Download verfügbar.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Patente',
    'ronlan.patTitle': 'Sieben Patente,<br><em>eines zentral für die Haut.</em>',
    'ronlan.patFeatBadge': 'Die Basis von Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Dieses Patent ist die chemische Grundlage von Transderma. Piceatannol ist der Wirkstoff von Serum R; die Retinoide (Retinylpalmitat) sind der Wirkstoff von Serum A. Das Patent beschreibt, wie diese beiden Moleküle auf der Haut zusammenwirken.',
    'ronlan.patFeatLinkA': 'Serum R kaufen',
    'ronlan.patFeatLinkB': 'Serum A kaufen',
    'ronlan.pat1': 'US Pat. 6,500,465 · Desinfektions- und sporizide Zusammensetzung · Gebäudedekontamination.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Zusammensetzung und Methode zum Reifenauswuchten.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Auswuchtzusammensetzung.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Reifenauswucht-Zusammensetzung.',
    'ronlan.pat5': 'European Patent EP1196299 · Reifenauswucht-Zusammensetzungen.',
    'ronlan.pat6': 'European Patent EP0281252 · Zusammensetzung und Methode zum Reifenauswuchten.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'Die angewandte Chemie',
    'ronlan.ctaTitle': 'Das Patent steckt<br><em>in der Flasche.</em>',
    'ronlan.ctaBody': 'Zwei der fünf Transderma-Seren stammen direkt aus dem kosmetischen Patent von Dr. Ronlán. Beginne dort, oder teste das ganze System im Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Retinoid',
    'ronlan.ctaBtnKit': 'Discovery Kit · alle fünf',

    /* ── PDF download footer ── */
    'ronlan.dlNote': 'Lieber das Originaldokument?',
    'ronlan.dlLink': 'Vollständigen Lebenslauf herunterladen (PDF) →'

  });
})();
